import React from 'react';
import DataServiceTabNav from '../Components/DataService/DataServiceTabNav';
import QueryBuilderComponent from '../Components/DataService/QueryBuilderComponent';

function DataServiceQueryPage() {
  return (
    <div className="bg-slate-950 text-slate-100">
      <DataServiceTabNav />
      <QueryBuilderComponent />
    </div>
  );
}

export default DataServiceQueryPage;


